<template>
  <v-card tile flat class="transparent">
    <div :id="parentDivID"/>
    <div class="gate-goal-container" v-if="gateEnabledOnMatch">
      <v-card v-show="this.gateOpened" class="goal-container-parent theme-back theme-title">
        <Goal ref="goal"/>
      </v-card>
      <v-btn tile :class="this.gateOpened ? 'goalBtn-clicked' : 'goalBtn-default'"
             class="theme-background theme-title pa-0" :disabled="gamefinished||isGateDisabled()" @click="toggleGate"
             depressed :style="this.gateOpened ? 'margin-right: -1px;' : ''">
        <img v-if="!gateOpened" class="theme-title"
             :src="isBallPlaced ? '/icons/gate_fill.svg' : '/icons/gate_empty.svg'" alt=""
             :style="isBallPlaced ? 'margin-top: -4px; margin-right: -4px;' : ''"/>
        <v-icon class="theme-title" v-if="gateOpened">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <v-snackbar v-model="courtWarning" :timeout="6000" top color="orange darken-3">
      A pálya nem ismerte fel az érintést. Koppintson egy színes pályaterületre -
      ha továbbra sem megy, az esemény a Mentés gombbal vázlatként elmenthető.
    </v-snackbar>
  </v-card>
</template>

<script>
import CourtCanvas from '../../court-canvas/build/courtCanvas';
import Goal from "@/components/Goal";
import eventBus from '@/eventBus';
import defaultBlockList from '@/DefaultBlockList';
import CONSTANTS from '@/constants';

import busListeners from "@/mixins/busListeners";
import Bugsnag from "@bugsnag/js";

const COURT_NOTIFY_MAX = 3;
let courtNotifyCount = 0;

export default {
    mixins: [busListeners],
  name: "Court",
  props: {
    parentDivID: String,
    canvasWidth: String,
    canvasHeight: String,
    theme: String,
    mirrored: Boolean,
    gamefinished: Boolean,
    gamedata: Object
  },
  data() {
    return {
      courtCanvas: null,
      parentDiv: null,
      initData: {},
      selectedArea: null,
      gateOpened: false,
      gateEnabledOnMatch: true,
      isBallPlaced: false,
      disabled: defaultBlockList(),
      gateDisabled: defaultBlockList(),
      direction: 'left',
      courtWarning: false,
    }
  },
  components: {
    Goal
  },
  methods: {
    setArea: function (id) {
      this.selectedArea = id;
    },
    setSize: function () {
      this.parentDiv.style.width = this.canvasWidth;
      this.parentDiv.style.height = this.canvasHeight;
    },
    // JAVÍTÁS (78. tétel): a pálya-canvas diagnosztikai jelzései. Breadcrumb
    // mindig (a következő Bugsnag-eseménynél látszik), önálló esemény csak a
    // rendellenes esetekre, oldalbetöltésenként legfeljebb COURT_NOTIFY_MAX.
    onCourtDiagnostic: function (type, meta) {
      const bugsnagReady = typeof Bugsnag.isStarted === 'function' && Bugsnag.isStarted();
      console.warn('[COURT] ' + type, meta);
      if (!bugsnagReady) return;
      Bugsnag.leaveBreadcrumb('Court ' + type, meta, 'state');
      const notifyTypes = ['colormap-rebuilt', 'colormap-rebuild-failed', 'miss-streak'];
      if (notifyTypes.includes(type) && courtNotifyCount < COURT_NOTIFY_MAX) {
        courtNotifyCount++;
        Bugsnag.notify('Court ' + type, function (event) {
          event.severity = 'info';
          event.context = 'Court ' + type;
          event.addMetadata('court', meta);
        });
      }
    },
    // Több egymás utáni, területet nem találó koppintás után szólunk a
    // felvevőnek - a 32021458074-es meccsen 2 percig koppintgattak visszajelzés nélkül.
    onCourtWarning: function () {
      this.courtWarning = true;
    },
    fillInitData: function () {
      this.initData["parentDiv"] = this.parentDiv;
      this.initData["onSelect"] = this.setArea;
      this.initData["onDiagnostic"] = this.onCourtDiagnostic;
      this.initData["onWarning"] = this.onCourtWarning;
      this.initData["backgroundImg"] = "background.svg";
      this.initData["linesImg"] = "lines.svg";
      this.initData["colorMap"] = "color_map.png";
      this.initData["theme"] = this.theme;
      this.initData["assetFolder"] = "/court";
      this.initData["area"] = [
        {
          "id": "0",
          "color": "#D248C7",
          "colorRight": "#691313",
          "selectedImg": "slice1.svg",
          "selectedImgRight": "slice5.svg",
          "isBtn": false
        },
        {
          "id": "1",
          "color": "#4EF074",
          "colorRight": "#E6BA0C",
          "selectedImg": "slice2.svg",
          "selectedImgRight": "slice4.svg",
          "isBtn": false
        },
        {
          "id": "2",
          "color": "#3F25DB",
          "colorRight": "#3F25DB",
          "selectedImg": "slice3.svg",
          "selectedImgRight": "slice3.svg",
          "isBtn": false,
        },
        {
          "id": "3",
          "color": "#E6BA0C",
          "colorRight": "#4EF074",
          "selectedImg": "slice4.svg",
          "selectedImgRight": "slice2.svg",
          "isBtn": false
        },
        {
          "id": "4",
          "color": "#691313",
          "colorRight": "#D248C7",
          "selectedImg": "slice5.svg",
          "selectedImgRight": "slice1.svg",
          "isBtn": false
        },
        {
          "id": "5",
          "color": "#927D29",
          "colorRight": "#8B23CE",
          "selectedImg": "slice6.svg",
          "selectedImgRight": "slice8.svg",
          "isBtn": false,
        },
        {
          "id": "6",
          "color": "#CFF812",
          "colorRight": "#CFF812",
          "selectedImg": "slice7.svg",
          "selectedImgRight": "slice7.svg",
          "isBtn": false,
        },
        {
          "id": "7",
          "color": "#8B23CE",
          "colorRight": "#927D29",
          "selectedImg": "slice8.svg",
          "selectedImgRight": "slice6.svg",
          "isBtn": false,
        },
        {
          "id": "8",
          "color": "#C40303",
          "colorRight": "#FF00C0",
          "selectedImg": "BA1.svg",
          "selectedImgRight": "BA3.svg",
          "isBtn": true
        },
        {
          "id": "9",
          "color": "#FD1F1F",
          "colorRight": "#FD1F1F",
          "selectedImg": "BA2.svg",
          "selectedImgRight": "BA2.svg",
          "isBtn": true,
        },
        {
          "id": "10",
          "color": "#FF00C0",
          "colorRight": "#C40303",
          "selectedImg": "BA3.svg",
          "selectedImgRight": "BA1.svg",
          "isBtn": true
        },
        {
          "id": "11",
          "color": "#C0BEAC",
          "colorRight": "#4CAF50",
          "selectedImg": "BT1.svg",
          "selectedImgRight": "BT3.svg",
          "isBtn": true
        },
        {
          "id": "12",
          "color": "#8BC34A",
          "colorRight": "#8BC34A",
          "selectedImg": "BT2.svg",
          "selectedImgRight": "BT2.svg",
          "isBtn": true,
        },
        {
          "id": "13",
          "color": "#4CAF50",
          "colorRight": "#C0BEAC",
          "selectedImg": "BT3.svg",
          "selectedImgRight": "BT1.svg",
          "isBtn": true
        },
        {
          "id": "14",
          "color": "#11BCD4",
          "colorRight": "#11BCD4",
          "selectedImg": "K.svg",
          "selectedImgRight": "K.svg",
          "isBtn": true,
        },
        {
          "id": "15",
          "color": "#121212",
          "colorRight": "#121212",
          "selectedImg": "FB.svg",
          "selectedImgRight": "FB.svg",
          "isBtn": true,
        },
        {
          "id": "16",
          "color": "#FE9801",
          "colorRight": "#FE9801",
          "selectedImg": "ST.svg",
          "selectedImgRight": "ST.svg",
          "isBtn": true
        }
      ];
    },
    toggleGate() {
      if (!this.isGateDisabled()) {
        this.gateOpened = !this.gateOpened;
      }
    },
    calculateDisabled() {
      // Megnézzük blokkolja-e valami
      let disabled = false;
      for (let disabledByComponent of Object.values(this.disabled)) {
        disabled |= disabledByComponent;
      }
      disabled = !!disabled; // Bool casting

      // Ha valami is blokkolja, disabled
      if (disabled) {
        this.setArea(null);
        this.courtCanvas.init(this.direction, null);
        this.courtCanvas.disable();
      } else {
        this.courtCanvas.enable();
      }
    },
    isGateDisabled() {
      // Megnézzük blokkolja-e valami
      let disabled = false;
      for (let disabledByComponent of Object.values(this.gateDisabled)) {
        disabled |= disabledByComponent;
      }
      disabled = !!disabled; // Bool casting
      if (disabled) {
        this.gateOpened = false;
      }
      return disabled;
    },
    disableCourt: function (component, value) {
      // Ne lehessen undefined, illetve csak létező komponens miatt lehessen blokkolva
      if (value === undefined || component === undefined || this.disabled[component] === undefined) {
        return;
      }

      this.disabled[component] = value;
      this.calculateDisabled();
    },
    disableGate: function (component, value) {
      // Ne lehessen undefined, illetve csak létező komponens miatt lehessen blokkolva
      if (value === undefined || component === undefined || this.gateDisabled[component] === undefined) {
        return;
      }

      this.gateDisabled[component] = value;
    }
  },
  mounted: function () {
    this.parentDiv = document.getElementById(this.parentDivID);
    this.parentDiv.style.overflow = "hidden";
    this.parentDiv.style.position = "absolute";
    // this.parentDiv.style.top = "0";
    // this.parentDiv.style.left = "0";

    //initData feltöltése
    this.fillInitData();
    // méret beállítása
    this.setSize();

    this.courtCanvas = new CourtCanvas(this.initData);
    this.courtCanvas.init(this.direction);

  },
  watch: {
    theme: function (newTheme) {
      this.courtCanvas.changeTheme(newTheme);
    },
    selectedArea: function (newVal) {
      let isEmpty = (newVal === null || newVal === undefined);
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.LOSTBALLS, {
        component: 'area',
        value: false,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTYSHOTS, {
        component: 'area',
        value: !isEmpty,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTIES, {
        component: 'area',
        value: !isEmpty,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.CARDS, {
        component: 'area',
        value: !isEmpty,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.SELECTED.AREA, newVal);
    },
    direction: function (newVal) {
      let area = this.selectedArea !== undefined ? this.selectedArea : null;
      this.courtCanvas.init(newVal, area);
      this.calculateDisabled();
    },
    isBallPlaced: function (isPlaced) {
      if (isPlaced) {
        this.gateOpened = false;
      }
    }
  },
  created() {
    let self = this;
    // JAVÍTÁS: ennek a késleltetett terület-törlés időzítőnek a nyomon
    // követésére kell, hogy a restoreAreaSelection (szerkesztés-visszaállítás)
    // le tudja állítani, ha időközben elindult - l. lentebb a RECORD.CREATED
    // és a restoreAreaSelection kezelőknél.
    self._areaClearTimeoutId = null;
    this.$busOn(CONSTANTS.ACTIONS.BALLPLACED, function (isPlaced) {
      self.isBallPlaced = isPlaced;
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.SHOTS, {
        component: 'gate',
        value: {
          'rontott': isPlaced,
          'kapufa': isPlaced,
          'gol': false,
          'vedett': false,
        },
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTYSHOTS, {
        component: 'gate',
        value: {
          'full': false,
          'rontott7m': isPlaced,
          'kapufa7m': isPlaced,
          'gol7m': false,
          'vedett7m': false,
          'rontott6m': isPlaced,
          'kapufa6m': isPlaced,
          'gol6m': false,
          'vedett6m': false,
        },
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.LOSTBALLS, {
        component: 'gate',
        value: isPlaced,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTIES, {
        component: 'gate',
        value: isPlaced,
      });
      eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.CARDS, {
        component: 'gate',
        value: isPlaced,
      });
    });
    this.$busOn(CONSTANTS.ACTIONS.TOGGLE.DIRECTION, function () {
      self.direction = self.direction === 'left' ? 'right' : 'left';
    });
    this.$busOn(CONSTANTS.EVENTS.CHANGE.DIRECTION, function (direction) {
      if (self.mirrored) {
        direction = direction === 'left' ? 'left' : 'right';
      } else {
        direction = direction === 'left' ? 'right' : 'left';
      }

      // JAVÍTÁS: mentés után (pl. gólnál) ez az esemény szinte AZONNAL lefut a
      // valódi RECORD.CREATED-del egy időben (a ReportScreen.vue a saját
      // RECORD.CREATED figyelőjéből hívja a támadási irány megfordítását).
      // Ha a self.direction itt azonnal vált, a pálya a MÉG TÖRÖLETLEN
      // (self.setArea(null) csak késleltetve fut le, l. lentebb) kiválasztott
      // területtel rajzolódik újra ÚJ irányban - mivel a területek indexei
      // iránytól függően más-más fizikai helyre képződnek le, a "sikeres
      // kiválasztás" zöld kiemelése emiatt a pálya egy MÁSIK, rossz részén
      // villant fel. A pálya vizuális fordítását ezért ugyanannyi ideig
      // késleltetjük, mint amennyivel a kiválasztás törlését (l. RECORD.CREATED
      // lejjebb) - így a felhasználó előbb a HELYES helyen látja a rövid
      // visszajelzést, és csak utána vált a pálya iránya.
      //
      // FONTOS: a "cancelled" RECORD.CREATED esemény kibocsátását NEM szabad
      // ezzel együtt késleltetni! Ez az esemény akkor is lefut, amikor egy
      // MEGLÉVŐ esemény SZERKESZTÉSÉT nyitjuk meg (az ActionBar.vue a
      // MODIFYITEMDATA-kezelője közben emittálja a CHANGE.DIRECTION-t, hogy a
      // pálya a szerkesztett esemény irányára álljon) - ilyenkor ez a "cancelled"
      // reset EREDETILEG szinkron, még a MODIFYITEMDATA-kezelő KÖZEPÉN futott
      // le, amit a kezelő hátralévő, később futó része (ami ténylegesen
      // feltölti a szerkesztési adatokat) mindig felülírt - ezért sosem
      // okozott látható problémát. Ha ezt is késleltetnénk, a reset a MÁR
      // TELJESEN megnyitott szerkesztőt törölné utólag, kidobva a
      // felhasználót szerkesztés közben (pontosan ez történt, amikor egyszer
      // már késleltetve volt).
      window.setTimeout(() => {
        self.direction = direction;
      }, 150);

      eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATED, {
        action: 'cancelled',
        params: {
          selectedAction: null,
          selectedTeamId: null,
          selectedPlayer: null,
          selectedArea: null,
          selectedGateArea: 0
        }
      });
    });
    this.$busOn(CONSTANTS.ACTIONS.DISABLE.COURT, function (value) {
      self.disableCourt(value.component, value.value);
    });
    this.$busOn(CONSTANTS.ACTIONS.DISABLE.GATE, function (value) {
      self.disableGate(value.component, value.value);
    });
    this.$busOn(CONSTANTS.EVENTS.RECORD.CREATED, function () {
      // JAVÍTÁS: ha a pálya-terület kiválasztása volt az utolsó hiányzó
      // paraméter, az automatikus mentés (és ezzel ez a RECORD.CREATED
      // esemény) szinte AZONNAL lefut a kattintás után - a korábbi kód itt
      // rögtön törölte is a kiválasztott terület kiemelését, mielőtt a
      // böngésző egyáltalán kirajzolhatta volna azt, így a felhasználó
      // soha nem látta a "sikeresen kiválasztva" visszajelzést. Egy rövid
      // késleltetéssel a kiemelés legalább egy pillanatra láthatóvá válik,
      // mielőtt eltűnik - a többi (interakció újra-engedélyezése) marad
      // azonnali, hogy a következő esemény rögzítése ne akadjon.
      //
      // JAVÍTÁS: ez a RECORD.CREATED (akár a valódi, akár a CHANGE.DIRECTION
      // által kibocsátott "cancelled" álesemény) egy MEGLÉVŐ ESEMÉNY
      // SZERKESZTÉSÉNEK MEGNYITÁSAKOR is lefut (az ActionBar.vue a
      // MODIFYITEMDATA-kezelője közben emittálja a CHANGE.DIRECTION-t) - ha
      // ez a késleltetett törlés ilyenkor is ütemeződik, 350ms-mal KÉSŐBB
      // fut le, mint a szerkesztés a "restoreAreaSelection" eseményen
      // keresztül helyesen visszaállítja a kiválasztott területet, és
      // törli/semmisre állítja azt - emiatt a szerkesztő megnyitásakor a
      // pálya sosem mutatta, honnan érkezett a lövés, és a mentés emiatt
      // vázlatként ment el (hiányzó "selectedArea" a validáláskor). Az
      // időzítő azonosítóját ezért eltároljuk, hogy a restoreAreaSelection
      // (lentebb) le tudja állítani, ha időközben elindult volna.
      if (self._areaClearTimeoutId) {
        window.clearTimeout(self._areaClearTimeoutId);
      }
      self._areaClearTimeoutId = window.setTimeout(() => {
        self.courtCanvas.clear();
        self.setArea(null);
        self._areaClearTimeoutId = null;
      }, 150);
      self.gateOpened = false;
      self.isBallPlaced = false;
      self.disableCourt('action', false);
      self.disableCourt('area', false);
      self.disableCourt('gate', false);
      self.disableCourt('player', false);
      self.disableGate('action', false);
      self.disableGate('area', false);
      self.disableGate('gate', false);
      self.disableGate('player', false);
    });
    this.$busOn(CONSTANTS.EVENTS.BASICMODECHANGED, function (value) {
      self.disableCourt('basic', value);
      self.disableGate('basic', value);
    });
    this.$busOn(CONSTANTS.ACTIONS.OPENGATE, function (open) {
      self.gateOpened = open;
      if (!open && self.$refs.goal) {
        self.$refs.goal.placeBall(0);
        self.isBallPlaced = false;
      }
    });
    this.$busOn('restoreAreaSelection', function (record) {
      // JAVÍTÁS: ha a szerkesztés-megnyitás korábbi lépéseként (CHANGE.DIRECTION
      // -> "cancelled" RECORD.CREATED) már ütemeződött egy késleltetett
      // terület-törlés, azt itt le KELL állítani - különben 350ms múlva
      // felülírná/törölné az itt éppen most helyesen visszaállított
      // kiválasztást (l. részletes magyarázat a RECORD.CREATED kezelőnél).
      if (self._areaClearTimeoutId) {
        window.clearTimeout(self._areaClearTimeoutId);
        self._areaClearTimeoutId = null;
      }
      self.courtCanvas.enable();
      if (record) {
        self.$nextTick(() => {
          self.selectedArea = record.selectedArea;
          self.courtCanvas.init(self.direction, self.selectedArea);
        });
      }
    });

    // 1. Azonnali ellenőrzés: Strand kézi esetén kényszerített Basic mód (Pálya és Kapu tiltása)
    if (self.gamedata && self.gamedata.rule === 'STRAND') {
      self.disableCourt('basic', true);
      self.disableGate('basic', true);
    } else {
      // 2. Adatbázisból lekérdezés normál terem esetén
      window.dbmanager.getConfig('basic').then((result) => {
        let isBasic = (result !== undefined && result !== null) ? result.value : false;
        self.disableCourt('basic', isBasic);
        self.disableGate('basic', isBasic);
      });
    }
  }
}
</script>

<style scoped>
.goalBtn-clicked {
  border-left-width: 1px;
  border-bottom-width: 1px;
  border-top-width: 1px;
  border-style: solid;
  border-right: 0;
}

.goalBtn-default, .goalBtn-clicked {
  display: inline-block;
  float: right;
  max-width: 43px !important;
  min-width: 43px !important;
  max-height: 43px !important;
  min-height: 43px !important;
  border-radius: 0 !important;
}

.theme--light.goalBtn-default, .theme--light.goalBtn-clicked {
  border-color: #000000 !important;
}

.theme--dark.goalBtn-default, .theme--dark.goalBtn-clicked {
  border-color: #ffffff !important;
}

.goal-container-parent {
  display: inline-block;
  float: right;
  max-width: 158px;
}
</style>
